const translation = {
  Product: "Sản phẩm",
  "Header.productNav": "Sản phẩm LUKKEY",
  Feature: "Tính năng",
  "About Us": "Về chúng tôi",
  FAQ: "Câu hỏi thường gặp",
  "Privacy Policy": "Chính sách bảo mật",
  "Help Center": "Trung tâm trợ giúp",
  "Header.infoMenu": "Thêm",
  "Header.appNow": "Tải ứng dụng",
  "Header.appModal.title": "Dùng ứng dụng LUKKEY ngay",
  "Header.appModal.subtitle": "Chọn nền tảng của bạn để tải ứng dụng di động chính thức của LUKKEY.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Cài đặt ứng dụng chính thức trên iPhone.",
  "Header.appModal.iosButton": "Mở",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Tải ứng dụng Android chính thức trên Google Play.",
  "Header.appModal.googlePlayButton": "Mở",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Tải trực tiếp APK chính thức mới nhất.",
  "Header.appModal.androidButton": "Tải xuống",
  "Header.appModal.note": "Chỉ cung cấp bản tải di động chính thức. Dùng các liên kết trên để lấy bản mới nhất.",
  "Academy": "Học viện",
  "Legal": "Pháp lý",
  "AboutUs.title": "Về LUKKEY",
  "AboutUs.lede": "LUKKEY là thương hiệu ví phần cứng của Thụy Sĩ, cam kết xây dựng tiêu chuẩn bảo mật cao nhất cho quyền sở hữu tài sản số.",
  "AboutUs.vision.closing": "Chìa khóa của bạn. Tài sản của bạn. Tương lai của bạn.",
  "AboutUs.quote": "LUKKEY xây dựng lớp bảo mật giữa con người và tài sản số.",
  "AboutUs.block1": "LUKKEY có trụ sở tại Thụy Sĩ. Công ty tập trung vào ví phần cứng được thiết kế cho self-custody an toàn.",
  "AboutUs.block2": "Sản phẩm của hãng kết hợp secure element, bảo vệ chống can thiệp và kiến trúc hoàn toàn ngoại tuyến. Mục tiêu là giữ khóa riêng trong một môi trường cách ly.",
  "AboutUs.block3": "Hệ thống được thiết kế không phụ thuộc vào Wi‑Fi, USB hay kết nối mạng trực tiếp. Truy cập vân tay, công cụ sao lưu NFC và hỗ trợ tài sản rộng giúp sản phẩm thực tế trong sử dụng hằng ngày.",
  "AboutUs.block5": "LUKKEY áp dụng cách tiếp cận mở và có thể kiểm toán cho firmware và phần mềm cốt lõi. Các tuyên bố về bảo mật cần có thể được kiểm tra và xác minh.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Yêu cầu hỗ trợ",
  "WarrantySupport.intro": "Vui lòng điền thông tin bên dưới để gửi yêu cầu hỗ trợ.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Tóm tắt vấn đề",
  "WarrantySupport.form.issueTitle.placeholder": "Nhập tóm tắt ngắn",
  "WarrantySupport.form.warrantyType.label": "Loại yêu cầu",
  "WarrantySupport.form.warrantyType.placeholder": "Chọn loại yêu cầu",
  "WarrantySupport.form.warrantyType.product": "Vấn đề thiết bị",
  "WarrantySupport.form.warrantyType.service": "Vấn đề ứng dụng/tài khoản",
  "WarrantySupport.form.warrantyType.replacement": "Khác",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Mô tả vấn đề hoặc yêu cầu chi tiết",
  "WarrantySupport.form.submit": "Gửi yêu cầu hỗ trợ",
  "WarrantySupport.alert.success": "Yêu cầu hỗ trợ của bạn đã được gửi!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Trung tâm trợ giúp",
  "HelpCenter.intro":
    "Chào mừng bạn đến với Trung tâm trợ giúp LUKKEY! Nếu bạn mới với tiền mã hóa hoặc cần trợ giúp về ví lạnh, bạn đã đến đúng nơi. Giải pháp ví lạnh của chúng tôi cung cấp cách an toàn nhất để lưu trữ và quản lý tài sản số của bạn. Bên dưới là câu trả lời cho những câu hỏi thường gặp và mẹo khắc phục sự cố.",
  "HelpCenter.section4.title": "Cần thêm hỗ trợ?",
  "HelpCenter.section4.intro":
    "Tiết kiệm thời gian bằng cách bắt đầu yêu cầu hỗ trợ trực tuyến, chúng tôi sẽ kết nối bạn với chuyên gia. Vì an toàn, hỗ trợ chính thức sẽ không bao giờ yêu cầu cụm từ khôi phục hoặc khóa riêng của bạn:",
  "HelpCenter.contact.hint": "Dùng nút để gửi yêu cầu hỗ trợ và chúng tôi sẽ liên hệ qua email.",
  "HelpCenter.cta.warranty": "Gửi yêu cầu hỗ trợ",
  brandName: "LUKKEY",
  tagline: "Quản lý tiền mã hóa của bạn theo cách chưa từng có",
  description:
    "Bắt đầu hành trình tự do tài chính của bạn với ứng dụng của chúng tôi. Bảo vệ tài sản của bạn với công nghệ ví lạnh tiên tiến của chúng tôi và quản lý tài chính một cách thông minh và hiệu quả. Sức khỏe tài chính của bạn là ưu tiên hàng đầu của chúng tôi.",
  "home.seoTitle": "LUKKEY | Ví phần cứng Thụy Sĩ cho self-custody an toàn",
  "home.seoDescription": "LUKKEY là thương hiệu ví phần cứng Thụy Sĩ tập trung vào bảo mật cold wallet, bảo vệ khóa riêng ngoại tuyến, truy cập bằng vân tay và sao lưu NFC cho self-custody an toàn.",
  learnMore: "Tìm hiểu thêm",
  "Lock Your Crypto, Securely": "Khóa tiền điện tử của bạn một cách an toàn",
  Testimonials: "Lời chứng thực",
  Testimonial1:
    "Tôi đã sử dụng ví lạnh này trong vài tháng và rất ấn tượng với độ tin cậy và các tính năng bảo mật của nó. Rất đáng để thử!",
  Testimonial2:
    "Ví lạnh này đã vượt quá mong đợi của tôi! Giao diện dễ sử dụng và bảo mật hàng đầu khiến nó trở thành công cụ cần thiết cho bất kỳ ai nghiêm túc với crypto.",
  Testimonial3:
    "Tôi đã thử một số ví lạnh trước đây, nhưng cái này nổi bật hơn. Thiết kế mượt mà và các tính năng tiên tiến giúp tôi quản lý tài sản crypto dễ dàng.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Người yêu thích tiền điện tử",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Người ủng hộ bảo mật tiền điện tử",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Chuyên gia phân tích đầu tư",
  "Touchscreen Interface": "Giao diện màn hình cảm ứng",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Trải nghiệm việc quản lý tiền điện tử dễ dàng với giao diện màn hình cảm ứng trực quan của chúng tôi, được thiết kế để điều hướng nhanh chóng và dễ dàng qua các tài sản kỹ thuật số của bạn, cho phép giao dịch nhanh chóng và quản lý an toàn chỉ với một cái chạm.",
  "Bluetooth Connectivity": "Kết nối Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Đồng bộ hóa không dây với các thiết bị của bạn để nhận cập nhật theo thời gian thực.",
  "Airtag Tracking": "Theo dõi Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Dễ dàng theo dõi ví của bạn với Airtag tích hợp sẵn.",
  "Secure Chip Technology": "Công nghệ chip bảo mật",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Được trang bị chip bảo mật tiên tiến, đảm bảo bảo vệ mạnh mẽ cho các tài sản kỹ thuật số quý giá của bạn khỏi truy cập trái phép và các mối đe dọa mạng.",
  "Cross-Platform Support": "Hỗ trợ đa nền tảng",
  "Works with various platforms for easy accessibility.":
    "Hoạt động với nhiều nền tảng để dễ dàng truy cập.",
  AboutUsDescription1:
    "Tại LUKKEY, chúng tôi cam kết cung cấp các giải pháp chất lượng cao để quản lý tài sản tiền điện tử của bạn một cách an toàn.",
  AboutUsDescription2:
    "Trụ sở chính của chúng tôi đặt tại Zug, Thụy Sĩ. Với một đội ngũ chuyên gia giàu kinh nghiệm, chúng tôi nỗ lực đổi mới và thích ứng với thị trường tiền kỹ thuật số luôn thay đổi.",
  BlockchainNetworksSupported: "Hỗ trợ các mạng Blockchain",
  CryptocurrenciesSupported: "Hỗ trợ hơn 6.000 loại tiền điện tử",
  Years: "Năm",
  ExpertiseInSecurity: "kinh nghiệm trong bảo mật",
  FrequentlyAskedQuestions: "Câu hỏi thường gặp",
  WhatIsColdWallet: "Cold Wallet là gì?",
  ColdWalletDescription:
    "Cold Wallet là một loại ví tiền điện tử lưu trữ tài sản của bạn ngoại tuyến, làm cho nó ít dễ bị tấn công và các mối đe dọa trực tuyến khác. Khác với ví nóng, ví nóng kết nối với internet và thuận tiện cho giao dịch thường xuyên, ví lạnh thích hợp cho việc lưu trữ lâu dài vì nó cung cấp mức độ bảo mật cao hơn.",
  HowToSetUpColdWallet: "Làm thế nào để thiết lập Cold Wallet?",
  ColdWalletSetupDescription:
    "Việc thiết lập Cold Wallet của bạn thường liên quan đến việc khởi tạo thiết bị trên một máy tính an toàn và không kết nối internet. Bạn sẽ cần tạo và lưu trữ một cụm từ phục hồi một cách an toàn, cụm từ này cần thiết để truy cập tài sản của bạn trong trường hợp mất thiết bị hoặc thiết bị bị hỏng. Hướng dẫn chi tiết được cung cấp khi bạn mua hàng để đảm bảo quá trình thiết lập suôn sẻ.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Các loại tiền điện tử nào tương thích với Cold Wallet của bạn?",
  CryptocurrenciesCompatibilityDescription:
    "Cold Wallet của chúng tôi hỗ trợ một loạt các loại tiền điện tử, bao gồm các loại phổ biến như Bitcoin, Ethereum và Litecoin, cũng như nhiều altcoin khác. Để có danh sách đầy đủ các đồng tiền hỗ trợ, vui lòng truy cập trang web của chúng tôi hoặc tham khảo tài liệu sản phẩm.",
  HowToSecureColdWallet: "Làm thế nào để đảm bảo Cold Wallet của tôi an toàn?",
  ColdWalletSecurityDescription:
    "Để bảo vệ Cold Wallet của bạn, luôn giữ cụm từ phục hồi ở một nơi an toàn và riêng tư, không chia sẻ nó với ai và cân nhắc sử dụng các biện pháp bảo mật bổ sung như khóa sinh trắc học hoặc hộp bảo vệ. Cập nhật phần mềm ví thường xuyên từ trang web chính thức cũng giúp bảo vệ khỏi các lỗ hổng.",
  ColdWalletNotWorking:
    "Tôi nên làm gì nếu Cold Wallet của tôi không hoạt động hoặc nếu tôi gặp lỗi?",
  ColdWalletErrorDescription:
    "Nếu bạn gặp sự cố với Cold Wallet của mình, hãy tham khảo phần khắc phục sự cố trong hướng dẫn sử dụng của chúng tôi. Đối với các vấn đề cụ thể hơn, liên hệ với đội hỗ trợ của chúng tôi qua trang web của chúng tôi. Hãy chắc chắn có thông tin thiết bị của bạn để làm nhanh chóng quá trình hỗ trợ.",
  Community: "Cộng đồng",
  "Subscribe.title": "Nhận cập nhật sản phẩm",
  "Subscribe.subtitle":
    "Chúng tôi theo dõi xu hướng crypto thay cho bạn. Nhận cập nhật sản phẩm, nhận định thị trường và ưu đãi độc quyền — gửi thẳng đến hộp thư của bạn.",
  "Subscribe.placeholder": "Nhập email của bạn",
  "Subscribe.button": "Đăng ký nhận cập nhật sản phẩm",
  "Subscribe.input.aria": "Trường nhập địa chỉ email",
  "Subscribe.success":
    "Cảm ơn bạn đã đăng ký! Vui lòng kiểm tra email xác nhận.",
  "Subscribe.error": "Đăng ký không thành công. Vui lòng thử lại sau.",
  "Subscribe.invalid": "Vui lòng nhập địa chỉ email hợp lệ.",
  "Subscribe.privacy":
    "Email của bạn chỉ được sử dụng để gửi bản tin và cập nhật. Bạn có thể hủy đăng ký bất cứ lúc nào bằng liên kết trong email.",
  "Subscribe.learnMore":
    "Tìm hiểu thêm về cách chúng tôi quản lý dữ liệu và quyền của bạn.",
  "Subscribe.popupCompact.title": "Luôn cập nhật",
  "Subscribe.popupCompact.subtitle":
    "Cập nhật sản phẩm và thông tin bảo mật. Không spam.",
  "Subscribe.popupCompact.button": "Đăng ký",
  "Subscribe.popupCompact.privacy":
    "Chỉ dùng email. Có thể hủy bất cứ lúc nào.",
  "SubscribeConfirmed.alt.success": "Đăng ký đã được xác nhận",
  "SubscribeConfirmed.alt.failed": "Đăng ký không thành công",
  "SubscribeConfirmed.title.success": "Đăng ký đã được xác nhận",
  "SubscribeConfirmed.title.failed": "Đăng ký không thành công",
  "SubscribeConfirmed.message.success":
    "Cảm ơn bạn đã xác nhận email. Đăng ký của bạn hiện đã được kích hoạt. Email chào mừng đã được gửi tới hộp thư của bạn.",
  "SubscribeConfirmed.message.failed":
    "Liên kết xác nhận không hợp lệ hoặc đã hết hạn. Vui lòng quay lại trang chủ và thử đăng ký lại.",
  "SubscribeConfirmed.cta.backHome": "Quay về trang chủ",
  "SubscribeConfirmed.note.unsubscribe":
    "Bạn có thể hủy đăng ký bất cứ lúc nào qua liên kết trong email của chúng tôi.",

  // ===== MarketView i18n =====
  "MarketView.title": "Bảng điều khiển thị trường",
  "MarketView.loading": "Đang tải...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Không thể hiển thị thẻ này",
  "MarketView.unknownError": "Lỗi không xác định",

  // ===== Common i18n =====
  "Common.refresh": "Làm mới",
  "Common.toggleSeriesVisibility": "Bật/tắt chuỗi này",
  "Common.error": "Lỗi",
  "Common.dataUpdateTime": "Thời gian cập nhật dữ liệu",
  "Common.loading": "Đang tải...",
  "Common.noDataSource": "Không có dữ liệu (chưa cung cấp nguồn dữ liệu)",

  // ===== Common ranges =====
  "Common.to": "đến",
  "Common.clear": "Xóa",
  "Common.range.thisMonth": "Tháng này",
  "Common.range.lastMonth": "Tháng trước",
  "Common.range.last2": "2 tháng gần đây",
  "Common.range.last3": "3 tháng gần đây",
  "Common.range.last6": "6 tháng gần đây",
  "Common.range.thisYear": "Năm nay",
  "Common.range.all": "Tất cả",
  "Common.range.custom": "Tùy chỉnh",
  "Common.showFilters": "Hiện bộ lọc",
  "Common.hideFilters": "Ẩn bộ lọc",
  "Common.search": "Tìm kiếm",
  "Common.priority": "Mức độ ưu tiên",
  "Common.owner": "Người phụ trách",
  "Common.collaborator": "Người phối hợp",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Tải xuống backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Tải xuống youtube_stats.json",
  "YouTubeTab.loading": "Đang tải số liệu YouTube...",
  "YouTubeTab.errorHint":
    "Nếu chưa cấu hình API Key, hãy đặt YOUTUBE_API_KEY hoặc GOOGLE_API_KEY trong backend/.env và khởi động lại backend.",
  "YouTubeTab.header.totalViews": "Tổng lượt xem (đa kênh, đơn vị: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Tổng người đăng ký (đa kênh, đơn vị: 10k)",
  "YouTubeTab.dist.views": "Phân bố lượt xem (10k)",
  "YouTubeTab.dist.subscribers": "Phân bố người đăng ký (10k)",
  "YouTubeTab.card.location": "Khu vực:",
  "YouTubeTab.card.registeredAt": "Đăng ký lúc:",
  "YouTubeTab.card.currentSubscribers": "Người đăng ký hiện tại",
  "YouTubeTab.card.currentVideos": "Số video hiện tại",
  "YouTubeTab.card.currentTotalViews": "Tổng lượt xem hiện tại",
  "YouTubeTab.card.currentTotalComments": "Tổng bình luận hiện tại",
  "YouTubeTab.chart.totalSubscribers": "Tổng người đăng ký",
  "YouTubeTab.chart.totalViews": "Tổng lượt xem",
  "YouTubeTab.chart.totalComments": "Tổng bình luận",
  "YouTubeTab.chart.totalVideos": "Tổng video",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Tải xuống backend data/x_stats.json",
  "XTab.downloadJson": "Tải xuống x_stats.json",
  "XTab.loading": "Đang tải số liệu X...",
  "XTab.errorHint":
    "Nếu chưa cấu hình Token, hãy đặt X_BEARER_TOKEN hoặc TWITTER_BEARER_TOKEN trong backend/.env và khởi động lại backend.",
  "XTab.header.totalFollowers": "Tổng người theo dõi (đa kênh, đơn vị: 10k)",
  "XTab.header.totalEngagement":
    "Tổng tương tác (5 bài gần nhất: Thích + Retweet + Trả lời + Trích dẫn, đơn vị: 10k)",
  "XTab.dist.followers": "Phân bố người theo dõi (10k)",
  "XTab.dist.engagement":
    "Phân bố tương tác (5 bài gần nhất: Thích + Retweet + Trả lời + Trích dẫn, đơn vị: 10k)",
  "XTab.card.currentFollowers": "Người theo dõi hiện tại",
  "XTab.card.currentFollowing": "Đang theo dõi hiện tại",
  "XTab.card.currentTweets": "Số tweet hiện tại",
  "XTab.card.recentLikes": "Lượt thích gần đây (5 bài gần nhất)",
  "XTab.card.recentRetweets": "Retweet gần đây (5 bài gần nhất)",
  "XTab.card.recentReplies": "Trả lời gần đây (5 bài gần nhất)",
  "XTab.card.recentQuotes": "Lượt xem gần đây (cấp nội dung, 5 bài gần nhất)",
  "XTab.card.listed": "Số lần vào danh sách (cấp kênh)",
  "XTab.smallChart.followers": "Người theo dõi",
  "XTab.smallChart.tweets": "Tweet",
  "XTab.smallChart.likes": "Lượt thích gần đây",
  "XTab.smallChart.retweets": "Retweet gần đây",
  "XTab.smallChart.replies": "Trả lời gần đây",
  "XTab.smallChart.quotes": "Lượt xem gần đây (cấp nội dung)",
  "XTab.smallChart.following": "Đang theo dõi",
  "XTab.smallChart.listed": "Trong danh sách",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Lọc theo tháng tạo:",
  "Analytics.dashboardTitle": "Bảng điều khiển sức khỏe dự án",
  "Analytics.metric.completionRate": "Tỷ lệ hoàn thành",
  "Analytics.metric.teamVelocity": "Tốc độ đội nhóm",
  "Analytics.metric.blockerRatio": "Tỷ lệ bị chặn",
  "Analytics.metric.workloadBalance": "Cân bằng khối lượng công việc",
  "Analytics.charts.statusDistribution": "Phân bố trạng thái",
  "Analytics.charts.statusByMonthPercent": "Trạng thái theo tháng (phần trăm)",
  "Analytics.charts.priorityDistribution": "Phân bố mức ưu tiên",
  "Analytics.charts.priorityByMonthPercent": "Ưu tiên theo tháng (phần trăm)",
  "Analytics.charts.functionTypeDistribution": "Phân bố theo loại chức năng",
  "Analytics.charts.functionTypeByMonthPercent":
    "Loại chức năng theo tháng (phần trăm)",
  "Analytics.blocker.ownerPie":
    "Vấn đề bị chặn · Phân bố người phụ trách (vòng)",
  "Analytics.blocker.ownerByMonth":
    "Vấn đề bị chặn · Người phụ trách theo tháng (phần trăm)",
  "Analytics.bug.ownerPie": "Vấn đề lỗi · Phân bố người phụ trách (vòng)",
  "Analytics.bug.ownerByMonth":
    "Vấn đề lỗi · Người phụ trách theo tháng (phần trăm)",
  "Analytics.ownerWorkloadDistribution":
    "Phân bố khối lượng công việc đội nhóm",
  "Analytics.mode.priority": "Phân bố mức ưu tiên",
  "Analytics.mode.status": "Phân bố trạng thái",
  "Analytics.mode.type": "Phân bố loại",
  "Analytics.blocker.attentionNeeded": "Vấn đề cần chú ý ngay",
  "Analytics.common.status": "Trạng thái",
  "Analytics.common.owner": "Người phụ trách",
  "Analytics.insights.sectionTitle": "Thông tin & khuyến nghị dự án",
  "Analytics.insights.efficiency.title": "Gợi ý cải thiện hiệu suất",
  "Analytics.insights.efficiency.completionRate":
    "• Tỷ lệ hoàn thành hiện tại là {{rate}}%, lưu ý các điểm bị chặn",
  "Analytics.insights.efficiency.avgVelocity":
    "• Tốc độ trung bình của đội là {{velocity}} nhiệm vụ/người",
  "Analytics.insights.efficiency.workloadBalance":
    "• Cân bằng khối lượng công việc là {{balance}}%",
  "Analytics.insights.risk.title": "Cảnh báo rủi ro",
  "Analytics.insights.risk.blockerRatio": "• Tỷ lệ bị chặn {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Tỷ lệ vấn đề P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Ưu tiên giải quyết vấn đề có mức ưu tiên cao trước",

  // ===== Kanban i18n =====
  "Kanban.title": "Chế độ xem Kanban",
  "Kanban.totalIssues": "Tổng {{count}} vấn đề",
  "Kanban.searchPlaceholder":
    "Tìm tiêu đề, số issue, người phụ trách hoặc người phối hợp...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "Đang thực hiện",
  "Kanban.status.blocked": "Bị chặn / Chờ xác nhận",
  "Kanban.status.reviewTest": "Xem xét / Kiểm thử",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Danh sách vấn đề",
  "List.totalIssues": "Tổng {{count}} vấn đề",
  "List.viewDetails": "Xem chi tiết",
  "List.openInNewWindow": "Mở trong cửa sổ mới",
  "List.empty.title": "Không có vấn đề",
  "List.empty.subtitle": "Tạo vấn đề đầu tiên để bắt đầu quy trình làm việc",

  // ===== Assets Register i18n =====
  "Assets.title": "Sổ đăng ký tài sản",
  "Assets.totalSets": "Tổng số bộ",
  "Assets.table.employee": "Nhân viên",
  "Assets.table.setCount": "Bộ",
  "Assets.table.model": "Mẫu",
  "Assets.total": "Tổng cộng",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Theo dõi vấn đề dự án",
  "LukkeyIssues.goToDemo": "Đến trang Demo",
  "LukkeyIssues.githubProject": "Dự án GitHub ↗",
  "LukkeyIssues.githubManageIssues": "Quản lý Issues trực tiếp trên GitHub ↗",
  "LukkeyIssues.financeModel": "Mô hình tài chính",
  "LukkeyIssues.productCoreIssues": "Vấn đề cốt lõi của sản phẩm",
  "LukkeyIssues.stats.totalIssues": "📊 Tổng số vấn đề",
  "LukkeyIssues.stats.completed": "✅ Đã hoàn thành",
  "LukkeyIssues.stats.inProgress": "🔄 Đang thực hiện",
  "LukkeyIssues.stats.pending": "⏳ Đang chờ",
  "LukkeyIssues.stats.blocked": "🚫 Bị chặn",
  "LukkeyIssues.stats.docs": "📚 Tài liệu",
  "LukkeyIssues.tabs.kanban": "Chế độ xem Kanban",
  "LukkeyIssues.tabs.analytics": "Phân tích",
  "LukkeyIssues.tabs.market": "Bảng điều khiển thị trường",
  "LukkeyIssues.tabs.assets": "Sổ đăng ký tài sản",
  "LukkeyIssues.shareToChatGPT": "Mở LUKKEY.json với ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Chính sách Quyền riêng tư của LUKKEY",
  "PrivacyPolicy.intro.p1":
    "Tại LUKKEY, chúng tôi tin rằng hình thức bảo vệ quyền riêng tư an toàn nhất là hình thức luôn nằm trong tay chính người dùng.",
  "PrivacyPolicy.intro.p2":
    "Vì vậy, dù bạn sử dụng phần cứng ví lạnh LUKKEY hay ứng dụng di động LUKKEY (App), chúng tôi luôn tuân thủ nghiêm ngặt một nguyên tắc bất di bất dịch:",
  "PrivacyPolicy.intro.p3_strong":
    "Trừ khi người dùng cho phép một cách rõ ràng, chúng tôi không thu thập, lưu trữ hay tải lên bất kỳ thông tin người dùng nào.",
  "PrivacyPolicy.intro.p3_tail":
    "Mọi dữ liệu liên quan đến việc sử dụng chỉ được lưu trữ cục bộ trên thiết bị của người dùng và không bao giờ được truyền tới LUKKEY hay bất kỳ máy chủ nào.",
  "PrivacyPolicy.intro.p4":
    "Chính sách Quyền riêng tư này giải thích cách chúng tôi thực thi nguyên tắc đó.",

  "PrivacyPolicy.s1.title": "1. Phạm vi áp dụng",
  "PrivacyPolicy.s1.appliesTo": "Chính sách Quyền riêng tư này áp dụng cho:",
  "PrivacyPolicy.s1.item.hardware": "Phần cứng ví lạnh LUKKEY",
  "PrivacyPolicy.s1.item.app": "Ứng dụng di động LUKKEY (App)",
  "PrivacyPolicy.s1.principle":
    "Cả hai đều theo nguyên tắc “không thu thập, không tải lên, chỉ lưu trữ cục bộ”.",

  "PrivacyPolicy.s2.title": "2. Thông tin chúng tôi KHÔNG thu thập",
  "PrivacyPolicy.s2.desc":
    "Để bảo vệ quyền riêng tư của bạn, chúng tôi cam kết rõ ràng không thu thập, tải lên hoặc lưu trữ bất kỳ thông tin người dùng nào, bao gồm nhưng không giới hạn ở:",
  "PrivacyPolicy.s2.li.identity":
    "Thông tin định danh: họ tên, số điện thoại, địa chỉ email, địa chỉ bưu chính",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Dữ liệu ví nhạy cảm: khóa riêng, cụm từ ghi nhớ (mnemonic), tệp keystore, mật khẩu ví",
  "PrivacyPolicy.s2.li.blockchain":
    "Dữ liệu blockchain: địa chỉ ví, lịch sử giao dịch, thông tin tài sản",
  "PrivacyPolicy.s2.li.behavior":
    "Hành vi sử dụng: nhật ký ứng dụng, bản ghi nhấp chuột, phân tích hành vi",
  "PrivacyPolicy.s2.li.technical":
    "Thông tin kỹ thuật: định danh thiết bị, vị trí địa lý, địa chỉ IP",
  "PrivacyPolicy.s2.inShort.title": "Tóm lại:",
  "PrivacyPolicy.s2.inShort.desc":
    "Mọi thứ bạn thấy trên thiết bị phần cứng và trong Ứng dụng chỉ tồn tại trên thiết bị của bạn. LUKKEY không thể truy cập.",

  "PrivacyPolicy.s3.title":
    "3. Thiết kế Quyền riêng tư & Bảo mật của ví lạnh (phần cứng)",
  "PrivacyPolicy.s3.desc":
    "Ví lạnh LUKKEY cung cấp môi trường hoàn toàn ngoại tuyến và an toàn. Các đặc điểm chính:",
  "PrivacyPolicy.s3.h1.title": "1. Phần cứng bảo mật cấp độ quân sự",
  "PrivacyPolicy.s3.h1.l1": "Secure Element đạt chứng nhận EAL6+",
  "PrivacyPolicy.s3.h1.l2": "Giao tiếp mã hóa ở cấp phần cứng trên toàn chuỗi",
  "PrivacyPolicy.s3.h2.title": "2. Chức năng bảo mật",
  "PrivacyPolicy.s3.h2.l1": "Xác thực vân tay",
  "PrivacyPolicy.s3.h2.l2": "Chế độ riêng tư",
  "PrivacyPolicy.s3.h2.l3": "Quản lý nhiều ví tách biệt",
  "PrivacyPolicy.s3.h3.title": "3. Cách ly hoàn toàn",
  "PrivacyPolicy.s3.h3.l1": "Không kết nối Internet",
  "PrivacyPolicy.s3.h3.l2": "Không kết nối cáp dữ liệu",
  "PrivacyPolicy.s3.h4.title": "4. Chống can thiệp với tự hủy",
  "PrivacyPolicy.s3.h4.desc":
    "Nếu thiết bị bị tháo rời, hư hỏng hoặc bị xâm nhập bất thường, Secure Element sẽ tự động hủy dữ liệu nhạy cảm để đảm bảo không thể trích xuất khóa riêng.",
  "PrivacyPolicy.s3.h5.title":
    "5. Thao tác nhạy cảm chỉ thực hiện trong Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Tạo ví",
  "PrivacyPolicy.s3.h5.l2": "Nhập ví",
  "PrivacyPolicy.s3.h5.l3": "Ký giao dịch",
  "PrivacyPolicy.s3.h5.note":
    "Mọi quy trình nhạy cảm diễn ra 100% trong Secure Element, không bao giờ phơi lộ ra bất kỳ chip hay vùng lưu trữ không an toàn nào.",
  "PrivacyPolicy.s3.h6.title":
    "6. Không lưu dữ liệu nhạy cảm bên ngoài Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "Các vùng lưu trữ không an toàn trên thiết bị không bao giờ lưu khóa riêng, cụm từ ghi nhớ hoặc bất kỳ thông tin nhạy cảm nào.",

  "PrivacyPolicy.s4.title":
    "4. Thiết kế Quyền riêng tư & Bảo mật của Ứng dụng LUKKEY",
  "PrivacyPolicy.s4.desc":
    "Ứng dụng LUKKEY chỉ tập trung vào hiển thị thông tin và cung cấp thông báo. Ứng dụng không xử lý dữ liệu ví nhạy cảm.",
  "PrivacyPolicy.s4.n1.title": "1. Ứng dụng KHÔNG làm",
  "PrivacyPolicy.s4.n1.l1": "Không tạo ví blockchain",
  "PrivacyPolicy.s4.n1.l2": "Không nhập ví blockchain",
  "PrivacyPolicy.s4.n1.l3": "Không lưu khóa riêng hoặc cụm từ ghi nhớ",
  "PrivacyPolicy.s4.n1.l4": "Không tải lên bất kỳ dữ liệu người dùng nào",
  "PrivacyPolicy.s4.n1.l5":
    "Không thực hiện phân tích hành vi, theo dõi quảng cáo hoặc thu thập dữ liệu",
  "PrivacyPolicy.s4.n2.title": "2. Ứng dụng THỰC HIỆN",
  "PrivacyPolicy.s4.n2.l1":
    "Hiển thị thông tin có thể truy cập công khai do phần cứng ủy quyền",
  "PrivacyPolicy.s4.n2.l2":
    "Cung cấp bảng cài đặt quyền riêng tư giải thích mục đích của từng quyền",
  "PrivacyPolicy.s4.n2.l3":
    "Trao cho người dùng toàn quyền bật/tắt quyền bất cứ lúc nào",
  "PrivacyPolicy.s4.n2.l4": "Cung cấp che mờ thông tin nhạy cảm",
  "PrivacyPolicy.s4.n2.l5": "Vô hiệu chụp màn hình/ghi màn hình ở một số màn",
  "PrivacyPolicy.s4.n2.l6":
    "Phát hiện địa chỉ blockchain đáng ngờ thông qua đối chiếu cục bộ",
  "PrivacyPolicy.s4.n2.l7":
    "Cập nhật định kỳ các URL, hợp đồng và địa chỉ nguy hiểm",
  "PrivacyPolicy.s4.n2.l8":
    "Luồng cập nhật một chiều: chỉ từ máy chủ → thiết bị",
  "PrivacyPolicy.s4.n2.l9":
    "Không có dữ liệu người dùng nào được gửi ngược lại trong quá trình cập nhật",
  "PrivacyPolicy.s4.n3.title": "3. Lưu trữ cục bộ",
  "PrivacyPolicy.s4.n3.p1":
    "Ứng dụng chỉ lưu trữ cục bộ dữ liệu không riêng tư như tùy chọn giao diện, ngôn ngữ và cài đặt chủ đề. Dữ liệu này:",
  "PrivacyPolicy.s4.n3.l1": "không được tải lên",
  "PrivacyPolicy.s4.n3.l2": "không được đồng bộ",
  "PrivacyPolicy.s4.n3.l3": "không thể truy cập bởi LUKKEY",

  "PrivacyPolicy.s5.title": "5. Truyền dữ liệu & Chính sách máy chủ",
  "PrivacyPolicy.s5.l1":
    "Máy chủ LUKKEY không lưu trữ bất kỳ thông tin người dùng nào",
  "PrivacyPolicy.s5.l2":
    "Giao tiếp Ứng dụng–máy chủ chỉ giới hạn ở cập nhật cơ sở dữ liệu và phiên bản",
  "PrivacyPolicy.s5.l3":
    "Không có thông tin người dùng nào được truyền trong quá trình giao tiếp",
  "PrivacyPolicy.s5.l4":
    "Ngay cả khi máy chủ bị xâm phạm, cũng không có dữ liệu người dùng nào bị lộ vì ngay từ đầu chúng tôi không thu thập những dữ liệu đó",

  "PrivacyPolicy.s6.title": "6. Minh bạch mã nguồn mở",
  "PrivacyPolicy.s6.l1": "Mã nguồn Ứng dụng LUKKEY là mã nguồn mở",
  "PrivacyPolicy.s6.l2": "Firmware nhúng của phần cứng LUKKEY là mã nguồn mở",
  "PrivacyPolicy.s6.l3":
    "Công khai hoàn toàn trên GitHub để bất kỳ ai cũng có thể kiểm tra",
  "PrivacyPolicy.s6.p": "Minh bạch là một phần của bảo mật.",

  "PrivacyPolicy.s7.title": "7. Kiểm soát hoàn toàn của người dùng",
  "PrivacyPolicy.s7.p":
    "Mặc dù chúng tôi không thu thập thông tin người dùng, người dùng vẫn có toàn quyền kiểm soát thiết bị của họ:",
  "PrivacyPolicy.s7.l1": "Bạn có thể tắt quyền của Ứng dụng bất cứ lúc nào",
  "PrivacyPolicy.s7.l2":
    "Bạn có thể gỡ cài đặt Ứng dụng để xóa toàn bộ dữ liệu cục bộ của ứng dụng",
  "PrivacyPolicy.s7.l3":
    "Bạn có thể đặt lại thiết bị phần cứng để xóa vĩnh viễn khóa riêng và dữ liệu ví",
  "PrivacyPolicy.s7.p2":
    "LUKKEY không và không thể can thiệp vào các hành động này.",

  "PrivacyPolicy.s8.title": "8. Liên hệ với chúng tôi",
  "PrivacyPolicy.s8.p":
    "Nếu bạn có bất kỳ câu hỏi nào liên quan đến Chính sách Quyền riêng tư này, vui lòng liên hệ:",
  "PrivacyPolicy.s8.email": "Email: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Địa chỉ: Trụ sở LUKKEY, Baarerstrasse 25, 6300 Zug, Thụy Sĩ",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Đang kiểm tra...",
  "EmailOtp.title":
    "Truy cập hạn chế: nhập họ tên và email để nhận mã đăng nhập",
  "EmailOtp.nameLabel": "Họ tên",
  "EmailOtp.namePlaceholder": "Nhập họ tên của bạn",
  "EmailOtp.emailLabel": "Email",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Gửi mã",
  "EmailOtp.resendCode": "Gửi lại mã",
  "EmailOtp.resendWithCountdown": "Gửi lại sau {{s}} giây",
  "EmailOtp.codeValidityHint":
    "Mã xác minh có hiệu lực trong 5 phút. Không chia sẻ mã cho bất kỳ ai.",
  "EmailOtp.codeLabel": "Mã xác minh qua email",
  "EmailOtp.codePlaceholder": "Nhập mã bạn đã nhận",
  "EmailOtp.signIn": "Đăng nhập",
  "EmailOtp.message.codeSent": "Mã xác minh đã được gửi tới email của bạn.",
  "EmailOtp.error.nameRequired": "Vui lòng nhập họ tên",
  "EmailOtp.error.invalidEmail": "Vui lòng nhập địa chỉ email hợp lệ",
  "EmailOtp.error.sendFailed": "Gửi mã xác minh không thành công",
  "EmailOtp.error.codeRequired": "Vui lòng nhập mã xác minh",
  "EmailOtp.error.verificationFailed": "Xác minh không thành công",
  // ===== Academy i18n =====
  "Academy.hero.alert": "Nhắc nhở bảo mật: luôn kiểm tra liên kết và không bao giờ chia sẻ cụm từ khôi phục.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Học viện",
  "Academy.hero.subtitle": "Các hướng dẫn thực tiễn về bảo mật crypto, tự lưu ký và cách sử dụng ví lạnh LUKKEY.",
  "Academy.search.placeholder": "Tìm hướng dẫn, best practice và câu hỏi thường gặp…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "BÀI VIẾT",
  "Academy.list.title": "Hướng dẫn mới nhất",
  "Academy.list.viewAll": "XEM TẤT CẢ",
  "Academy.list.empty": "Không có kết quả. Hãy thử từ khóa khác.",
  "Academy.image.placeholder": "HÌNH",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Quay lại Học viện",
  "AcademyArticle.notFound": "Không tìm thấy bài viết",
  "AcademyArticle.author": "Tác giả",
  "AcademyArticle.unscheduled": "Chưa có thời gian xuất bản dự kiến",
  "home.hero.reserveCtaLabel": "Quyền truy cập sớm — 1 USD",
  "home.hero.reserveCtaNote": "Hoàn tiền toàn bộ. Không cam kết mua hàng."
};
export default translation;
